<template>
  <div class="centerdiv">
    <h2>出题</h2>
    <el-row>
      <el-col :span=8>
        <el-row class="rowheight">
          <el-col :span="6" class='labright'>guid</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.guid" placeholder="guid，可以是fh1之类"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>main</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.main" placeholder="数学长征中题号"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>problemImg</el-col>
          <el-col :span="18" class='xtextleft'>
            <el-input v-model="pInfo.problemImg" placeholder="问题图片,用辅助上传OSS中的工具上传"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>answer</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.answer" placeholder="答案只能输入"></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" class='labright'>rank</el-col>
          <el-col :span="18" class='textleft'>
            <el-input v-model="pInfo.rank" placeholder="题目难度级别"></el-input>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span=16>
        <el-row>
          <el-col :span="18" >
            <el-button type="primary" @click="commit" style="width:150px">提交</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { addNewFhProblem } from '@/api/problems'

  export default {
    data () {
      return {
        value: '',
        pInfo: {
          guid: '',
          main: '',
          problemImg: '',
          answer: '',
          rank: ''
        }
      }
    },
    computed: {
      ...mapGetters([
        'welcome'
      ])
    },
    created () {
      // this.tableHandler()
      // container: this.toolbarOptions,
    },
    mounted () {
    },
    methods: {
      commit () {
        addNewFhProblem(this.pInfo).then((res) => {
          if (res.data) {
            // console.log('res.data.isOk--' + JSON.stringify(res.data.isOk))
            if (res.data.isOk === true) {
              this.showMsg('保存新题成功。', 'info')
            } else {
              this.showMsg('添加题目失败。', 'info')
            }
          } else {
            this.showMsg('保存新题不成功。', 'info')
          }
        }).catch(err => {
          this.showMsg(`保存新题失败。${err}`)
        })
      },
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '烽火数学出题',
          message: msg,
          type: type
        })
      }
    }
  }
</script>

<style scoped>
  .centerdiv {
    height: auto;
    text-align: center;
  }

  .labright {
    height: 50px;
    line-height: 40px;
    text-align: right;
    vertical-align: middle;
  }
  .rowheight{
    text-align: right;
    vertical-align: middle;
  }
  .textleft {
    text-align: left;
    height: 30px;
  }

  .lableft {
    text-align: left;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #20a0ff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// fhCreateProblem.vue?09504aec